import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 全局组件注册
import pageTop from '@/components/page/pageTop.vue'
Vue.component('pageTop', pageTop) //
import pageBread from '@/components/common/pageBread.vue'
Vue.component('pageBread', pageBread) //

// import VConsole from "vconsole";
// if (VConsole) {
//   new VConsole();
// }

// import "lib-flexible";//网页适配

import '@/css/css-reset.css' // css reset
import '@/plugin/request.js'
import '@/plugin/message.js'
import '@/plugin/log.js'
import '@/lib/lib-flexible.js'

import Directives from './directives' //全局指令
Vue.use(Directives)

import * as filters from '@/filters/index' //全局过滤器
Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key])
})

import zh from './langurage/zh.js' //中文
import en from './langurage/en.js' //英文
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import locale_ui_zh from 'element-ui/lib/locale/lang/zh-CN' //组件中文
import locale_ui_en from 'element-ui/lib/locale/lang/en' //组件英文
const messages = {
    zh: {
        ...zh,
        ...locale_ui_zh,
    },
    en: {
        ...en,
        ...locale_ui_en,
    },
}
let locale = sessionStorage.getItem('lang') || 'zh'

const i18n = new VueI18n({
    locale: locale,
    messages,
})
// 加载
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/element-#FF4D00/index.css' // 改 element ui 全局颜色
import { Loading } from 'element-ui'

// import "@/css/index.css"; // 自定义主题
Vue.use(ElementUI, {
    locale_ui_zh,
    locale_ui_en,
    i18n: (k, v) => i18n.t(k, v),
})

// 自定义滚动条
// import "perfect-scrollbar/css/perfect-scrollbar.css"
// import PerfectScrollbar from 'perfect-scrollbar'

// 混入
import _mixin from '@/mixins/index.js'
Vue.mixin(_mixin)

Vue.prototype.$load = {
    loading: null,
    open: function () {
        this.loading = Loading.service({
            fullscreen: true,
        })
    },
    close: function () {
        return new Promise(async (resolve, reject) => {
            if (!this.loading) {
                resolve()
                return false
            }
            setTimeout(() => {
                this.loading.close()
                resolve()
            }, 0)
        })
    },
}

import { cloneDeep } from './util/cloneDeep'
Vue.prototype.$cloneDeep = cloneDeep

import { uploadFile, uploadFileList } from '@/util/upload'
Vue.prototype.$uploadFile = uploadFile
Vue.prototype.$uploadFileList = uploadFileList

store.dispatch('appInit') //重新初始化

Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app')
